import { useContext } from "react";

import { FilterOptions } from "@app/network-portfolio-management/interfaces";
import { useGetFilterOptions } from "@app/network-portfolio-management/services/npmQueries";
import { useNPMView } from "@app/network-portfolio-management/hooks/useNPMView";
import { UserContext } from "@app/user/UserContext";

interface UseFilterOptionsResult {
  filterOptions: FilterOptions | null;
  filterOptionsError: boolean;
}

/**
 * Loads the dashboard filter dropdown options once per user and view, and exposes them along with an error
 * flag. The options derive from the current user's accessible-project set, so userId (resolved from
 * UserContext) is part of the cache key; the result is also scoped to the current NPM view (e.g. the Hidden
 * view's dropdowns reflect only the hidden set's available attributes) so switching users or views refetches.
 * Cancellation on unmount is handled by react-query via the AbortSignal it provides.
 */
export function useFilterOptions(): UseFilterOptionsResult {
  const userId = useContext(UserContext)?.userId;
  const view = useNPMView().getCurrentNpmView();

  const { data, error } = useGetFilterOptions(userId, view);

  return {
    filterOptions: data ?? null,
    filterOptionsError: error != null,
  };
}
